import { useSyncExternalStore } from 'react'

/** The console's one breakpoint for layout swaps: ≤860px is mobile (drawer nav, card lists). */
export const NARROW_QUERY = '(max-width: 860px)'

// jsdom has no matchMedia; there, and before hydration, the console is wide.
const hasMatchMedia = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function'

function subscribe(onChange: () => void) {
  if (!hasMatchMedia()) return () => {}
  const media = window.matchMedia(NARROW_QUERY)
  media.addEventListener('change', onChange)
  return () => media.removeEventListener('change', onChange)
}

/** True at ≤860px, where tables give way to cards and the sidebar becomes a drawer. */
export function useNarrow(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => hasMatchMedia() && window.matchMedia(NARROW_QUERY).matches,
    () => false,
  )
}
